import './axios'
import './fontawesome'
import './vue-js-modal'
import './vue-popper'
import './vue-tippy'
import './vuejs-datepicker'
import './vue-select'
import './v-calendar'
import './vue-toastification'
import './vue-slider-component'
import './maska'
import './vue-click-outside'
import './lazyImg'
import './safe-phone'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
